import {getAppState} from "../helpers/tools";
import StakeholderDetails from "../helpers/StakeholderDetails";
import Worker from "worker-loader!../workers/stakeholder.worker.js";

/**
 *
 * @param stakeholder
 * @returns {Function}
 */
export const setStakeholder = (stakeholder) => {
  return dispatch => {
    dispatch({type: "SET_STAKEHOLDER", data: stakeholder});
  }
};

/**
 *
 * @param stakeholder
 * @returns {Function}
 */
export const fetchStakeholder = (stakeholder) => {
  return (dispatch, getState) => {
    dispatch({type: "FETCH_STAKEHOLDER", data: stakeholder});
    const state = getAppState( getState() );
    try {
      if (state.actions.history.length < 20) {
        const details = new StakeholderDetails(state.actions.history, state.location.model, stakeholder);
        dispatch({
          type: "FETCH_STAKEHOLDER_FULFILLED",
          data: details.getHTML()
        });
      } else {
        const worker = new Worker();
        worker.postMessage([state, stakeholder]);
        worker.addEventListener('message', event => {
          dispatch({
            type: "FETCH_STAKEHOLDER_FULFILLED",
            data: event.data,
          });
        });
      }
    } catch (e) {
      dispatch({
        type: "FETCH_STAKEHOLDER_REJECTED",
        data: e
      });
    }
  }
};
